// ROUTE CONST TO PREVENT TYPO
export default {
  //  ========== CHANNEL ==========
  HOME: 'home',
  ANIMATION: 'animation',
  PR_TEMPLATES: 'premiere-pro-templates',
  AE_TEMPLATES: 'after-effects-templates',
  MOTION_TEMPLATES: 'apple-motion-templates',
  THREE_D: '3d',
  VIDEO: 'video',
  STOCK_IMAGE: 'stock-image',
  GIF: 'gif',
  SFX: 'sound-effects',
  MUSIC: 'music',
  LOTTIE: 'lottie',
  UI: 'ui',
  PRESENTATION: 'presentation',
  GRAPHIC: 'graphic',
  MIDJORNEY: 'midjourney-prompts',
  PROMPT: 'prompt',
  DAVINCHI_RESOLVE_TEMPLATES: 'davinci-resolve-templates',
  VIEW: 'view',
  AUDIOSEARCH: 'audiosearch',
  VISUALSEARCH: 'visualsearch',
  //  ========== ACCOUNT ==========
  LOGIN: 'login',
  SIGNUP: 'signup',
  ACCOUNT: 'account',
  DASHBOARD: 'dashboard',
  FORGOT_PASSWORD: 'forgot-password',
  LOST_PASSWORD: 'lost-password',
  RESET_PASSWORD: 'reset-password',
  PHOTO_ID: 'photo-id',
  SETTINGS: 'settings',
  CREDITS: 'credits',
  SUBSCRIPTION: 'subscription',
  PURCHASE_HISTORY: 'purchase-history',
  DOWNLOADS: 'downloads',
  PASSWORD: 'password',
  PAYMENT_METHODS: 'payment-methods',
  //  ========== FREE ==========
  FREE: 'free', // url
  // PR_TEMPLATES: 'premiere-pro-templates', // SAME AS CHANNEL
  // AE_TEMPLATES: 'after-effects-templates', // SAME AS CHANNEL
  FCPX_TEMPLATES: 'fcpx-motion-templates',
  STOCK_FOOTAGE: 'stock-footage',
  GIFS: 'gifs',
  BG_MUSIC: 'background-music',
  //  ========== DLP, CATEGORY ==========
  DLP: 'dlp',
  CATEGORY: 'category',
  // SFX: 'sound-effects', // SAME AS CHANNEL
  // MUSIC: 'music', // SAME AS CHANNEL
  // THREE_D: '3d', // SAME AS CHA\NNEL
  // VIDEO: 'video', // SAME AS CHANNEL
  // ANIMATION: 'animation',
  PR: 'premiere-pro',
  AE: 'after-effects',
  IMAGE: 'image',
  MOTION: 'apple-motion',
  RESOLVE: 'davinci-resolve',
  //  ========== ARTISTS ==========
  ARTISTS: 'contributors',
  ARTIST_STEP: 'artist-step',
  ARTIST_STEPS: 'artist-steps',
  CONTRIBUTOR_STEPS: 'contributor-steps',
};
